import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './webprofile.css';
import { useParams } from "react-router-dom";

import gifimage from './tick1.gif'
const Payment = () => {
  const [paymentstatus, setpaymentstatus] = useState('');
  const [paymenttext, setpaymenttext] = useState('Initializing payment..');
  const { id } = useParams();

  useEffect(() => {
    paymentfunction();
  }, []);

  const showLoader = () => (
    <div className="bouncing-ball">
      <div className="bouncing-ball"></div>
    </div>
  );

  const paymentfunction = async () => {
    try {
      console.log('Fetching order for id:', id);

      // 1. Create order using per-business keys
      const result = await axios({
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        url: `https://us-central1-jiffybook-india.cloudfunctions.net/createOrder?parameter=${id}`,
        data: {
          currency: 'INR',
        },
      });

      console.log('Order result:', result.data);
      setpaymentstatus(result.data.strPayStatus);

      if (result.data.strPayStatus !== 'Paid') {

        // 2. Use razorpayKeyId returned from backend (per-business key)
        const options = {
          key: result.data.razorpayKeyId,
          amount: result.data.amount * 100,
          currency: 'INR',
          name: result.data.strBname,
          description: 'Transaction',
          order_id: result.data.orderId,
          prefill: {
            name: result.data.strCname,
            email: result.data.strCmail,
            contact: '9000090000',
          },
          notes: {
            address: 'Indreamer Corporate Office',
          },
          handler: async function (response) {
            try {
              setpaymentstatus('');
              console.log('Payment response:', response);

              // 3. Verify and save — now includes strBID for key lookup
              await axios({
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
                url: `https://us-central1-jiffybook-india.cloudfunctions.net/verifyAndSaveOrderPayment`,
                data: {
                  paymentid: response.razorpay_payment_id,
                  orderid: response.razorpay_order_id,
                  signature: response.razorpay_signature,
                  numBookingTotalCost: result.data.amount,
                  numClaim: result.data.numClaim,
                  numPaid: result.data.amount,
                  strBID: result.data.strBID,       // ← used to look up key_secret
                  strBname: result.data.strBname,
                  strCmail: result.data.strCmail,
                  strCname: result.data.strCname,
                  strCurrency: result.data.strCurrency,
                  strExtRef: response.razorpay_signature,
                  strRCID: result.data.strRCID,
                  strTcode: result.data.strTcode,
                },
              });

              console.log('Payment verified and saved.');
              setpaymentstatus('Paid');

            } catch (error) {
              console.error('Error verifying payment:', error);
              setpaymentstatus('Unpaid');
              setpaymenttext('Verification failed. Contact support.');
            }
          },
          theme: {
            color: '#3399cc',
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();

        rzp.on('payment.failed', function (response) {
          setpaymentstatus('Unpaid');
          setpaymenttext('Payment failed');
          console.log('Payment failed:', response.error);
        });

      } else {
        console.log('Already paid');
      }

    } catch (error) {
      console.error('Error in paymentfunction:', error);
      setpaymentstatus('Unpaid');
      setpaymenttext('Something went wrong. Please try again.');
    }
  };

  return (
    <div>
      {paymentstatus === '' && (
        <div style={{ marginLeft: '48%', marginTop: 50 }}>
          {showLoader()}
        </div>
      )}

      {paymentstatus !== 'Paid' ? (
        <h2 style={{ textAlign: 'center' }}>{paymenttext}</h2>
      ) : (<div style={{
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  minHeight: '50vh' // Ensures vertical centering relative to full screen height
}}>
  
  <img src={gifimage} style={{height:40,width:40}}alt="Payment status animation" />
  <h2>Payment completed.</h2>
  <p>You may now close this window.</p>
</div>
      )}
    </div>
  );
};

export default Payment;